import Footermain from "./Footer_main";
import achieve from"./content/achievement.png";
import "./css-components/about.css";
//images
import ava1 from "./content/avatar1.jpg";
import ava2 from "./content/avatar2.jpg";
import ava3 from "./content/avatar3.jpg";
import ava4 from "./content/avatar4.jpg";
import ava5 from "./content/avatar5.jpg";

function About(){

    return(
      <>

       {/* =============================Achievement======================== */}
        <section className="about__achievements">
          <div className="container about__achievements-container">
            <div className="about__achievements-left">
              <img src={achieve} alt="" />
            </div>
            <div className="about__achievements-right">
              <h1>Achievements</h1>
              <p>Lorem ipsum dolor sit, amet consectetur adipisicing elit. Sunt necessitatibus nisi vel cum eaque! Vel eum, accusantium illo pariatur iste eos facere officia totam id!</p>
           
            <div className="achievements__cards">
              <article className="achievement__card">
                  <span className="achievement__icon">
                  <i class="fa-solid fa-video"></i>
                  </span>
                  <h3>63+</h3>
                  <p>Courses</p>
              </article>
              <article className="achievement__card">
                  <span className="achievement__icon">
                    <i class="fa-solid fa-user-group"></i>
                  </span>
                  <h3>1100+</h3>
                  <p>Students</p>
              </article>
              <article className="achievement__card">
                  <span className="achievement__icon">
                    <i class="fa-solid fa-trophy"></i>
                  </span>
                  <h3>15+</h3>
                  <p>Awards</p>
              </article>
            </div>
            </div>
          </div>
        </section>


        {/* =============================our team======================== */}
        <section className="team">
          <h2>Meet our Team</h2>
          <div className="container team__container">
            <article className="team__member">
                 <div className="team__member-image">
                   <img src={ava2} alt="" />
                 </div>
                 <div className="team__member-info">
                   <h4>Sunil</h4>
                   <p>Web Developer</p>
                 </div>
                 <div className="team__member-socials">
                   <a href="https://instagram.com" target="_blank"rel="noreferrer"><i class="fa-brands fa-instagram"></i></a>
                   <a href="https://twitter.com" target="_blank"rel="noreferrer"><i class="fa-brands fa-twitter"></i></a>
                   <a href="https://linkedin.com" target="_blank"rel="noreferrer"><i class="fa-brands fa-linkedin"></i></a>
                 </div>
            </article>

            <article className="team__member">
                 <div className="team__member-image">
                   <img src={ava1} alt="" />
                 </div>
                 <div className="team__member-info">
                   <h4>Sonam</h4>
                   <p>Web Designer</p>
                 </div>
                 <div className="team__member-socials">
                   <a href="https://instagram.com" target="_blank"rel="noreferrer"><i class="fa-brands fa-instagram"></i></a>
                   <a href="https://twitter.com" target="_blank"rel="noreferrer"><i class="fa-brands fa-twitter"></i></a>
                   <a href="https://linkedin.com" target="_blank"rel="noreferrer"><i class="fa-brands fa-linkedin"></i></a>
                 </div>
            </article>

            <article className="team__member">
                 <div className="team__member-image">
                   <img src={ava3} alt="" />
                 </div>
                 <div className="team__member-info">
                   <h4>Ayush</h4>
                   <p>Expert Tutor</p>
                 </div>
                 <div className="team__member-socials">
                   <a href="https://instagram.com" target="_blank"rel="noreferrer"><i class="fa-brands fa-instagram"></i></a>
                   <a href="https://twitter.com" target="_blank"rel="noreferrer"><i class="fa-brands fa-twitter"></i></a>
                   <a href="https://linkedin.com" target="_blank"rel="noreferrer"><i class="fa-brands fa-linkedin"></i></a>
                 </div>
            </article>

            <article className="team__member">
                 <div className="team__member-image">
                   <img src={ava3} alt="" />
                 </div>
                 <div className="team__member-info">
                   <h4>Devansh</h4>
                   <p>Developer</p>
                 </div>
                 <div className="team__member-socials">
                   <a href="https://instagram.com" target="_blank"rel="noreferrer"><i class="fa-brands fa-instagram"></i></a>
                   <a href="https://twitter.com" target="_blank"rel="noreferrer"><i class="fa-brands fa-twitter"></i></a>
                   <a href="https://linkedin.com" target="_blank"rel="noreferrer"><i class="fa-brands fa-linkedin"></i></a>
                 </div>
            </article>

            <article className="team__member">
                 <div className="team__member-image">
                   <img src={ava5} alt="" />
                 </div>
                 <div className="team__member-info">
                   <h4>Aman</h4>
                   <p>Expert Tutor</p>
                 </div>
                 <div className="team__member-socials">
                   <a href="https://instagram.com" target="_blank"rel="noreferrer"><i class="fa-brands fa-instagram"></i></a>
                   <a href="https://twitter.com" target="_blank"rel="noreferrer"><i class="fa-brands fa-twitter"></i></a>
                   <a href="https://linkedin.com" target="_blank"rel="noreferrer"><i class="fa-brands fa-linkedin"></i></a>
                 </div>
            </article>

            <article className="team__member">
                 <div className="team__member-image">
                   <img src={ava2} alt="" />
                 </div>
                 <div className="team__member-info">
                   <h4>Sagar</h4>
                   <p>Developer</p>
                 </div>
                 <div className="team__member-socials">
                   <a href="https://instagram.com" target="_blank"rel="noreferrer"><i class="fa-brands fa-instagram"></i></a>
                   <a href="https://twitter.com" target="_blank"rel="noreferrer"><i class="fa-brands fa-twitter"></i></a>
                   <a href="https://linkedin.com" target="_blank"rel="noreferrer"><i class="fa-brands fa-linkedin"></i></a>
                 </div>
            </article>

            <article className="team__member">
                 <div className="team__member-image">
                   <img src={ava2} alt="" />
                 </div>
                 <div className="team__member-info">
                   <h4>Siddhart</h4>
                   <p>Web Designer</p>
                 </div>
                 <div className="team__member-socials">
                   <a href="https://instagram.com" target="_blank"rel="noreferrer"><i class="fa-brands fa-instagram"></i></a>
                   <a href="https://twitter.com" target="_blank"rel="noreferrer"><i class="fa-brands fa-twitter"></i></a>
                   <a href="https://linkedin.com" target="_blank"rel="noreferrer"><i class="fa-brands fa-linkedin"></i></a>
                 </div>
            </article>

            <article className="team__member">
                 <div className="team__member-image">
                   <img src={ava4} alt="" />
                 </div>
                 <div className="team__member-info">
                   <h4>Kalpana</h4>
                   <p>Web Developer</p>
                 </div>
                 <div className="team__member-socials">
                   <a href="https://instagram.com" target="_blank"rel="noreferrer"><i class="fa-brands fa-instagram"></i></a>
                   <a href="https://twitter.com" target="_blank"rel="noreferrer"><i class="fa-brands fa-twitter"></i></a>
                   <a href="https://linkedin.com" target="_blank"rel="noreferrer"><i class="fa-brands fa-linkedin"></i></a>
                 </div>
            </article>
          </div>

        </section>
        <Footermain/>
     </>
    )
}
export default About;